// ─── 삭제 확인 모달 ───────────────────────────────────────────────────────────
import React from 'react';
import { Modal, Button } from 'react-bootstrap';

/**
 * 질의 기록 삭제 전 최종 확인 모달.
 * @param {{ row: object, onClose: function, onConfirm: function, isDeleting: boolean }} props
 */
export default function DeleteConfirmModal({ row, onClose, onConfirm, isDeleting }) {
  if (!row) return null;
  return (
    <Modal
      show centered
      onHide={() => !isDeleting && onClose()}
      contentClassName="rounded-2xl border-0 shadow-xl"
    >
      <Modal.Header className="border-b border-gray-100 px-5 py-3">
        <Modal.Title className="text-base font-bold text-sb-header">질의 삭제</Modal.Title>
        {!isDeleting && (
          <button type="button" className="modal-btn-close" onClick={onClose}>
            <span className="modal-btn-span">X</span>
          </button>
        )}
      </Modal.Header>
      <Modal.Body className="px-5 py-4">
        <p className="text-sm text-gray-700">이 질의 기록을 삭제할까요? 삭제 후에는 복구할 수 없습니다.</p>
        <p className="mt-2 font-mono text-[11px] text-gray-500">#{row.turn_id}</p>
        <p className="mt-1 line-clamp-2 text-xs text-gray-600">{row.question || '—'}</p>
      </Modal.Body>
      <Modal.Footer className="border-0 px-5 pb-4">
        <Button variant="light" disabled={isDeleting} onClick={onClose}>취소</Button>
        <Button variant="danger" disabled={isDeleting} onClick={onConfirm}>
          {isDeleting ? '삭제 중…' : '삭제'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
